import React, { useState } from "react";
import ConZoom from "./ConZoom";
import { trocear } from "./glosario";
import { infoServicio } from "modAws/CatalogoAws";

// Piezas pequeñas de la guia.

// Texto con las palabras del glosario subrayadas (punteado); al pasar el cursor aparece la definicion.
export const Glosa = ({ texto }) => (
    <>
        {trocear(texto).map((t, i) => t.termino
            ? <abbr key={i} title={`${t.termino.t}: ${t.termino.d}`} style={{ textDecoration: "underline dotted", textUnderlineOffset: 3, cursor: "help" }}>{t.texto}</abbr>
            : <React.Fragment key={i}>{t.texto}</React.Fragment>)}
    </>
);

export const NIVELES = {
    basico: { texto: "Básico", clase: "text-bg-success", ayuda: "Conviene conocerlo primero" },
    intermedio: { texto: "Intermedio", clase: "text-bg-warning", ayuda: "Requiere conocer lo básico" },
    avanzado: { texto: "Avanzado", clase: "text-bg-danger", ayuda: "Para casos específicos o equipos con experiencia" },
};
export const Nivel = ({ nivel }) => {
    const n = NIVELES[nivel];
    return n ? <span className={`badge ${n.clase}`} title={n.ayuda}>{n.texto}</span> : null;
};

// Mapa de relaciones: el servicio al centro y, alrededor, aquellos con los que suele trabajar. Cada uno se puede pulsar.
export const MapaRelaciones = ({ centro, ids, onElegir }) => {
    const lista = ids.filter(id => infoServicio(id)).slice(0, 8);
    const c = { x: 200, y: 120 };
    const R1 = 78, R2 = 150, RY = 78;
    const pos = lista.map((_, i) => { const a = -Math.PI / 2 + (i * 2 * Math.PI) / lista.length; return { x: c.x + (R2 - 10) * Math.cos(a), y: c.y + RY * Math.sin(a) * 1.15 }; });
    const ic = infoServicio(centro);
    return (
        <ConZoom>
        <svg viewBox="0 0 400 250" width="100%" role="img" aria-label={`Servicios relacionados con ${ic.servicio.title}`} style={{ maxHeight: 300, display: "block" }}>
            {pos.map((p, i) => <line key={i} x1={c.x} y1={c.y} x2={p.x} y2={p.y} stroke={ic.color} strokeOpacity="0.35" strokeWidth="1.6" />)}
            {lista.map((id, i) => {
                const inf = infoServicio(id);
                return (
                    <g key={id} style={{ cursor: "pointer" }} onClick={() => onElegir(id)} role="button" tabIndex={0} onKeyDown={e => { if (e.key === "Enter") onElegir(id); }}>
                        <circle cx={pos[i].x} cy={pos[i].y} r="29" fill="#fff" stroke={inf.color} strokeWidth="2" />
                        <text x={pos[i].x} y={pos[i].y + 4} textAnchor="middle" fontSize="9.5" fontWeight="700" fill={inf.color}>{inf.servicio.title.length > 10 ? inf.servicio.title.slice(0, 9) + "…" : inf.servicio.title}</text>
                        <title>{inf.servicio.title}</title>
                    </g>
                );
            })}
            <circle cx={c.x} cy={c.y} r="38" fill={ic.color} fillOpacity="0.15" stroke={ic.color} strokeWidth="3" />
            <text x={c.x} y={c.y + 4} textAnchor="middle" fontSize="12" fontWeight="800" fill={ic.color}>{ic.servicio.title.length > 12 ? ic.servicio.title.slice(0, 11) + "…" : ic.servicio.title}</text>
        </svg>
        </ConZoom>
    );
};

// Pregunta de repaso: al responder se muestra si fue correcta y por que.
export const Quiz = ({ quiz, color, onCorrecto }) => {
    const [resp, setResp] = useState(null);
    if (!quiz) return null;
    const responder = (i) => { if (resp != null) return; setResp(i); if (i === quiz.c && onCorrecto) onCorrecto(); };
    return (
        <div>
            <p className="mb-2"><b>{quiz.p}</b></p>
            <div className="d-grid gap-2">
                {quiz.o.map((op, i) => {
                    const ok = resp != null && i === quiz.c, mal = resp === i && i !== quiz.c;
                    return (
                        <button key={i} className={`btn btn-sm text-start ${ok ? "btn-success" : mal ? "btn-danger" : "btn-outline-secondary"}`} disabled={resp != null && !ok && !mal} onClick={() => responder(i)}>
                            {ok && <i className="fa fa-check me-2" />}{mal && <i className="fa fa-times me-2" />}{op}
                        </button>
                    );
                })}
            </div>
            {resp != null && (
                <div className={`alert ${resp === quiz.c ? "alert-success" : "alert-warning"} py-2 small mt-2 mb-0`} style={{ borderLeft: `4px solid ${color}` }}>
                    <b>{resp === quiz.c ? "¡Correcto!" : "No exactamente."}</b> {quiz.e}
                    {resp !== quiz.c && <div><button className="btn btn-link btn-sm p-0 mt-1" onClick={() => setResp(null)}>Intentar de nuevo</button></div>}
                </div>
            )}
        </div>
    );
};
